module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true,
      "appendToBody": true,
      "isCloseOnEsc": !_vm.theEditUser
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__content text-dark"
  }, [_c('div', {
    staticClass: "d-modal__content__sidebar"
  }, [_c('h2', [_vm._v("Opsætning af vikarløn")]), _vm._v(" "), _c('ul', {
    staticClass: "d-modal__content__sidebar__nav"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      staticClass: "d-modal__content__sidebar__nav-item",
      class: {
        'd-modal__content__sidebar__nav-item--active': tab.id === _vm.theActiveTab
      },
      on: {
        "click": function($event) {
          return _vm.setTheActiveTab(tab.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content__body"
  }, [_c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), (_vm.isInitLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [(_vm.theActiveTab === 1) ? _c('SalarySettingsUsers', {
    attrs: {
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
    },
    on: {
      "setEditUser": _vm.setEditUser,
      "changedMade": function($event) {
        _vm.isChangesMade = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('SalaryRule1', {
    attrs: {
      "schoolIds": [_vm.schoolId],
      "config": _vm.config,
      "propRules": _vm.rules,
      "schoolSubstituteRules": _vm.schoolSubstituteRules
    },
    on: {
      "changedMade": function($event) {
        _vm.isChangesMade = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('SalaryRule2', {
    attrs: {
      "config": _vm.config,
      "propRules": _vm.rules
    },
    on: {
      "onSubmit": _vm.updateSchoolConfiguration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('SalaryRule3', {
    attrs: {
      "config": _vm.config,
      "propRules": _vm.rules
    },
    on: {
      "onSubmit": _vm.updateSchoolConfiguration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 5) ? _c('SalaryRule4', {
    attrs: {
      "config": _vm.config,
      "propRules": _vm.rules
    },
    on: {
      "onSubmit": _vm.updateSchoolConfiguration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 6) ? _c('CostCenters') : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 7) ? _c('SalaryCodes') : _vm._e()]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ca9fa21!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettings.vue
// module id = 1533
// module chunks = 1